/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgUnderlineS = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M490 1700v-222q38 34 91 60t113 45 118 29 110 10q63 0 125-10t111-38 79-76 31-126q0-68-33-119t-88-93-124-77-143-71-142-78-124-95-88-121-34-160q0-114 50-195t130-134 180-76 199-25q39 0 85 2t92 8 91 17 79 30v213q-81-56-175-77t-191-22q-57 0-118 12t-110 40-82 74-32 116q0 28 5 55t18 52q22 44 66 80t101 68 122 65 131 67 125 77 107 92 73 116 28 146q0 83-23 147t-63 112-94 81-119 54-134 30-140 9q-40 0-95-6t-113-18-109-29-86-39zm-106 220h1280v128H384v-128z"
    }));
export default SvgUnderlineS;
